// eslint-disable-next-line no-restricted-imports
import dayjs from '../dayjsConfig';

const getNowMs = (timeZone?: string) => (timeZone ? +dayjs().tz(timeZone) : +new Date());

export default getNowMs;
